import { URLSearchParams, QueryEncoder } from '@angular/http';
import { URLParams } from '../../core/url-params.model';

export class DashboardHttpUtil {

  public static prepareTokenParam(token): URLSearchParams {
    let urlParams = new URLParams();

    if (token) {
      urlParams.append('securityToken', token);
    }
    return urlParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.util.ts